import { loadStripe } from '@stripe/stripe-js';

// Singleton Stripe promise — loads Stripe.js once and reuses across the app
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

export default stripePromise;
